import { renderColorPrimary } from "@/common/function/FunctionTheme";
import styled from "styled-components";

export const DisplayLabelDropdownWrapper = styled.div<{$theme?: string; $isActive?: boolean}>`
  display: flex;
  align-items: center;
  margin-left: -2px;
  .label-dropdown {
    font-size: 12px;
    margin-left: 4px;
    font-weight: ${(props) => props.$isActive ? 500 : undefined};
    color: ${(props) => props.$isActive ? renderColorPrimary(props.$theme) : ""};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: calc(100% - 20px);
  }
`;
